// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import IdleHandler from './IdleHandler';
import { ToastProvider } from './Components/ui/Toast';
import { ConfirmProvider } from './Components/ui/ConfirmDialog';

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <ToastProvider>
        <ConfirmProvider>
          <IdleHandler>
            <App />
          </IdleHandler>
        </ConfirmProvider>
      </ToastProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
